<h2 mat-dialog-title>Réinitialisation du modèle</h2>
<mat-dialog-content>
  <p>
    Étes-vous sûr(e) de vouloir réinitialiser votre modèle aux données par
    défaut ? Votre scénario actuel sera définitivement supprimé.
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Non</button>
  <button mat-button (click)="onClickReset()">Oui</button>
</mat-dialog-actions>
